import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePostCompanySalesperson = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await companyApis.post('/dashboard/company/{id}/salesperson/', {
        path: { id },
      });
      if (response[400]) {
        throw new FormError('PostCompanySalesperson', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/`]);
        queryClient.invalidateQueries([`/dashboard/company/${id}/detail/`]);
      },
    },
  );
};
